import api from '../api';

export interface MatchingOptions {
  id: string;
  documentoInfo: string;
  valor: number;
}

export const getAllDocumentosToMatching = (autorizacaoId: string, numeroContrato: string) =>
  api.get<MatchingOptions[]>(`matching/documentos?autorizacaoId=${autorizacaoId}&numeroContrato=${numeroContrato}`);

export const getAllSituacaoAutorizacao = () =>
  new Promise<any | undefined>((resolve, reject) => {
    let itens = [
      {
        text: 'Pendênte',
        value: '0',
      },
      {
        text: 'Erro',
        value: '1',
      },
      {
        text: 'Matching Realizado',
        value: '2',
      },
    ];
    resolve(itens);
  });

export const getAllMatchingOptions = (autorizacaoId: string, numeroContrato: string) =>
  getAllDocumentosToMatching(autorizacaoId, numeroContrato).then(documento => {
    let result = (documento || []).map(a => ({
      text: a.documentoInfo + ' - R$ ' + a.valor.toString(),
      value: a.id.toString(),
    }));
    result.push({ text: 'ERROR', value: '0' });
    // result.push({ text: 'PENDENTE', value: '1' });
    return result;
  });
